module.exports = __webpack_public_path__ + "static/media/Michelle2-Portfolio.f7a182aa.png";